<template>
  <div
    class="absolute h-screen w-screen z-[999] flex gap-15 bg-white py-[7%] px-[20%]">
    <div class="flex flex-1 flex-col gap-9">
      <ScrollableContainer>
        <div class="whitespace-pre-line p-2">{{ message }}</div>
      </ScrollableContainer>
      <BaseButton
        class="self-end flex justify-center items-center w-24"
        size="sm"
        @click="$emit('close')">
        <span>{{ buttonText }}</span>
        <ChevronLeft class="stroke-white w-4 ltr:rotate-180" />
      </BaseButton>
    </div>
    <div class="flex flex-1">
      <BaseImage
        :src="HotAirBalloon"
        width="300px"
        height="100%"
        density="compact"
        alt="intro_img"
        placement="center"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  BaseImage,
  BaseButton,
  ScrollableContainer,
} from '@nwire/amit-design-system';
import HotAirBalloon from '/@/assets/hotAirBalloon.svg?url';
import { ChevronLeft } from 'lucide-vue-next';

defineProps({
  buttonText: {
    type: Boolean,
    default: true,
  },
  message: {
    type: String,
    required: true,
  },
});

defineEmits(['close']);
</script>
